import { PaymentProviderType, ServerAccountByIdType, ServerAccountType } from '@expane/data'
import { TFunction } from 'react-i18next'

export const ACCOUNT_TYPES = [
  { id: 1, name: 'accountType.permanent', hint: 'accountType.permanentHint' },
  { id: 2, name: 'accountType.internal', hint: 'accountType.internalHint' },
]

export const filterAccountsWithoutChosen = (
  accounts: ServerAccountType[],
  chosenAccount: number | undefined,
): ServerAccountType[] => accounts.filter(account => account.id !== chosenAccount)

export const getCurrentAccount = (
  accounts: ServerAccountType[] | undefined,
  currentAccountId: number,
): ServerAccountType | undefined => accounts?.find(account => account.id === currentAccountId)

export const isAccountForPayments = (accountTypeId: number): boolean => {
  return accountTypeId === ACCOUNT_TYPES[0].id
}

export const getIsAccountWithPOS = (
  accountById: ServerAccountByIdType | ServerAccountType | undefined,
) => (accountById ? !Boolean(accountById.accountSoftwarePOS?.length) : true)

export type ServerAccountWithInactiveReason = ServerAccountType & {
  inactiveReason?: string
}

export const getAccountsWithInactiveReason = (
  accounts: ServerAccountType[],
  paymentProviders: PaymentProviderType[],
  t: TFunction,
): ServerAccountWithInactiveReason[] => {
  return accounts.map(account => {
    const hasPaymentProvider = paymentProviders?.some(
      provider => provider.account.id === account.id,
    )
    return hasPaymentProvider
      ? { ...account, inactiveReason: t('account.inactiveReason') }
      : account
  })
}

export const getAccountsWithoutPaymentProvider = (
  accounts: ServerAccountType[],
  paymentProviders: PaymentProviderType[],
): ServerAccountType[] => {
  return accounts.filter(
    account => !paymentProviders?.some(provider => provider.account.id === account.id),
  )
}

export const getAvailableDefaultAccountId = (
  accounts: { id: number }[],
  defaultAccountId?: number,
): number | undefined => {
  if (!accounts?.length) return undefined
  return accounts.some(acc => acc.id === defaultAccountId) ? defaultAccountId : accounts[0]?.id
}
